import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface State {
  loading: boolean;
  error: string | null;
}

const initialState: State = {
  loading: false,
  error: null,
};

const slice = createSlice({
  name: "cartMutation",
  initialState,
  reducers: {
    mutationStart: (s) => {
      s.loading = true;
      s.error = null;
    },
    mutationSuccess: (s) => {
      s.loading = false;
    },
    mutationError: (s, a: PayloadAction<string>) => {
      s.loading = false;
      s.error = a.payload;
    },
  },
});

export const { mutationStart, mutationSuccess, mutationError } = slice.actions;

export default slice.reducer;
